import { render, staticRenderFns } from "./MedicationPlanDownload.vue?vue&type=template&id=a0e0bf50&scoped=true&"
import script from "./MedicationPlanDownload.vue?vue&type=script&lang=js&"
export * from "./MedicationPlanDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e0bf50",
  null
  
)

export default component.exports